// extracted by mini-css-extract-plugin
module.exports = {"digit":"Digit_digit__b1jy2","digitContent":"Digit_digitContent__Em3oK"};